import { useEffect } from 'react'

export default function useRippleEffect() {
  useEffect(() => {
    const buttons = document.querySelectorAll(".ripple-animate");
      
    buttons.forEach(function(button){
      button.addEventListener("click", function(e){
        let x = e.clientX - e.target.offsetLeft;
        let y = e.clientY - e.target.offsetTop;
        var ripple = document.createElement("span");
        ripple.classList.add("ripple-circle");
        ripple.style.left = x + "px";
        ripple.style.top = y + "px";
        
        button.appendChild(ripple);
        setTimeout(function(){
          ripple.remove();
        }, 1000);
      });
    });
  })
}